<template>
  <div class="custom-paas-edit">
    <paasEdit
      ref="paasEdit"
      :params="params"
      :config="config"
      :menuApiName="menuApiName"
      :fetchSubData="fetchSubData"
      @loaded="loaded"
    />
  </div>
</template>

<script>
import paasEdit from '../../pages/edit/index.vue'
import paasApi from './api'
import {merge, cloneDeep} from 'lodash-es'
// 统一响应处理
import response from '../../../../../utils/response'
import i18n from './i18n.js'
import {HEADER_PARAMS_KEYS, BUTTON_API_NAME, LAYOUT_TYPE} from 'fe-coms-share/paas/constants'
import menuHandleMixin from '../mixin/menu-handle'

const pageText = window.fe.getPageText(i18n)

export default {
  props: {
    pageParams: {
      type: Object,
      default: null
    },
    pageConfig: {
      type: Object,
      default: () => ({})
    },
    configType: String
  },
  mixins: [menuHandleMixin],
  computed: {
    headerParams () {
      const {layoutApiName, objectApiName, tenantType, permissionPointCode} = this.params
      return {
        [HEADER_PARAMS_KEYS.tenantType]: tenantType,
        [HEADER_PARAMS_KEYS.objectApiName]: objectApiName,
        [HEADER_PARAMS_KEYS.layoutApiName]: layoutApiName,
        [HEADER_PARAMS_KEYS.operationApiName]: permissionPointCode,
        [HEADER_PARAMS_KEYS.menuApiName]: this.menuApiName
      }
    },
    paasPage () {
      return this.$refs.paasEdit
    }
  },
  data () {
    const id = this.pageParams ? this.pageParams.id : this.$route.query.id
    const params = this.pageParams || this.$route.params
    const {objectApiName, permissionPointCode} = params
    params.operationApiName = permissionPointCode
    return {
      params,
      id,
      formData: {},
      config: merge({
        [objectApiName]: {
          buttons: {
            [BUTTON_API_NAME.BUTTON_SUBMIT]: {
              event: {
                submit: this.handleSubmit
              }
            }
          }
        }
      }, this.pageConfig)
    }
  },
  methods: {
    loaded (schema) {
      this.$emit('loaded', schema)
    },
    async fetchSubData ({subSchema}) {
      if (this.configType !== 'popupConfig') {
        this.isEdit = !!this.id
        if (this.isEdit) {
          await this.formDataHandle(subSchema)
        }
        this.$nextTick(() => {
          this.paasPage.updateData(this.formData)
        })
      } else {
        this.$set(this, 'formData', cloneDeep(this.pageParams.row) || {})
        this.$nextTick(() => {
          this.paasPage.updateData(this.formData)
        })
      }
    },
    async formDataHandle (subSchema) {
      const data = await this.getDetail()
      await Promise.all(
        (subSchema || []).map(v => {
          return this.getSubDetail(data, v)
        })
      )
      this.formData = data
    },
    async getSubDetail (data, {objectApiName: subObjectApiName, layoutApiName, subObjectParamName, relationFieldApiName}) {
      const {objectApiName} = this.params
      const api = paasApi.getSlaveForUpdate
      const promise = this.$http(api.type, api.url + `/${objectApiName}/${subObjectApiName}/${layoutApiName}/${relationFieldApiName}`, {
        aPaaS_SequenceId: this.id
      }, this.headerParams)
      const res = await response(promise)
      let content = []
      if (res.isOk) {
        content = res.content
      }
      data[subObjectParamName] = content
    },
    async getDetail () {
      const {objectApiName, operationApiName} = this.params
      const api = paasApi.getForUpdate
      const promise = this.$http(api.type, api.url + `/${objectApiName}/${operationApiName}`, {
        aPaaS_SequenceId: this.id
      }, this.headerParams)
      const res = await response(promise)
      if (res.isOk) {
        return res.content
      }
      return {}
    },
    // 提交
    async handleSubmit ({data, isEdit, layoutType}) {
      let api = isEdit ? paasApi.valueUpdate : paasApi.valueCreate

      // 判断聚合页面新建
      if (layoutType === LAYOUT_TYPE.LAYOUT_TYPE_POLYMERIC_CREATE) {
        api = paasApi.valueBatchCreate
      }

      const {objectApiName, operationApiName} = this.params
      const _url = `${api.url}/${objectApiName}/${operationApiName}`
      const promise = this.$http(api.type, _url, data, this.headerParams)
      const res = await response(promise, {
        loadingOptions: {
          text: pageText.submission
        }
      })
      if (res.isOk) {
        this.$message({
          message: pageText.submitSuccessfully,
          type: 'success'
        })
        this.$router.go(-1)
      }
    }
  },
  components: {
    paasEdit
  }
}
</script>
<style scoped lang='scss'>
.custom-paas-edit ::v-deep .field-group .render {
  .render-string {
    margin: 0 2.5px;
    display: inline;
  }

  .sy-form-item {
    margin: 0 2.5px 5px;
    vertical-align: middle;
  }
}

.custom-paas-edit ::v-deep .field-group .render .render-string:first-child {
  margin-left: 0;
}
</style>
